module.exports = __webpack_public_path__ + "static/media/reddit.b5d79608.svg";